import { getPdfViewerToolbarSelectableOptions } from '../../PdfViewerToolbar.utils'

import {
  PDF_VIEWER_SCROLL_MODE_OPTIONS,
  PDF_VIEWER_SPREAD_MODE_OPTIONS,
  PDF_VIEWER_VIEW_CONTROLS_SECTION_ID,
} from './PdfViewerToolbarViewControlsTool.constants'

export function getPdfViewerViewControlsSections({
  scrollMode,
  spreadMode,
  onChangeScrollMode,
  onChangeSpreadMode,
  onRotateClockwise,
  onRotateCounterClockwise,
}) {
  return [
    {
      id: PDF_VIEWER_VIEW_CONTROLS_SECTION_ID.pageTransition,
      options: getPdfViewerToolbarSelectableOptions({
        options: PDF_VIEWER_SCROLL_MODE_OPTIONS,
        selectedValue: scrollMode,
        onSelect: onChangeScrollMode,
      }),
      titleKey: 'PdfViewer.PageTransitionKey',
    },
    {
      id: PDF_VIEWER_VIEW_CONTROLS_SECTION_ID.pageOrientation,
      options: [
        {
          qaName: 'pdfViewerRotateClockwise',
          titleKey: 'PdfViewer.RotateClockwiseKey',
          onSelect: onRotateClockwise,
        },
        {
          qaName: 'pdfViewerRotateCounterClockwise',
          titleKey: 'PdfViewer.RotateCounterClockwiseKey',
          onSelect: onRotateCounterClockwise,
        },
      ],
      titleKey: 'PdfViewer.PageOrientationKey',
    },
    {
      id: PDF_VIEWER_VIEW_CONTROLS_SECTION_ID.pageLayout,
      options: getPdfViewerToolbarSelectableOptions({
        options: PDF_VIEWER_SPREAD_MODE_OPTIONS,
        selectedValue: spreadMode,
        onSelect: onChangeSpreadMode,
      }),
      titleKey: 'PdfViewer.PageLayoutKey',
    },
  ]
}
